import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import NotificationInterface from '../../interfaces/client/Notification'

import {
  selectPassengerForDeletion,
  deselectPassengerForDeletion,
} from '../../actions/deletePassengers'
import { removeNotification } from '../../actions/notifications'

import {
  getFieldNotification,
  getWarningNotifications,
} from '../../utils/notifications'
import parseFlightId from '../../utils/parseFlightId'
import { maxDifferenceTwoYearsBetweenDates } from '../../utils/validation'
import infantDateOfBirthValidation from '../../utils/forms/infantDateOfBirthValidation'

import EditBookingFormInfantRow from '../../components/EditBookingFormInfantRow'

interface EditBookingFormInfantRowPropsInterface {
  passengerId: string
  flightId: string
  rowId: number
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  { passengerId, rowId, flightId }: EditBookingFormInfantRowPropsInterface
) => {
  const passenger = state.passengers.byId[passengerId]
  const infantId =
    passenger.infant && passenger.infant.id ? passenger.infant.id : passengerId
  const passengerErrors =
    state.notifications.passengerIdsToNotificationIds[infantId]
  const departureDate = parseFlightId(flightId).date

  const errors: NotificationInterface[] = Boolean(passengerErrors)
    ? getWarningNotifications(
        passengerErrors.map(
          (notificationKey: string) => state.notifications.byId[notificationKey]
        )
      )
    : []

  const firstNameError = getFieldNotification(errors, 'FirstName', true)
  const lastNameError = getFieldNotification(errors, 'LastName', true)
  const dateOfBirthError = getFieldNotification(errors, 'DateOfBirth', true)

  const passengersSelectedForDeletion =
    state.passengersToBeDeleted.passengersSelectedForDeletion

  const infantDetails =
    passenger && passenger.infant
      ? {
          infantId: passenger.infant.id || '',
          firstName: passenger.infant.firstName,
          lastName: passenger.infant.lastName,
          dateOfBirth: passenger.infant.dateOfBirth,
          gender: passenger.infant.gender,
        }
      : {
          infantId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
        }

  return {
    ...infantDetails,
    rowId,
    passengerId,
    firstNameError,
    lastNameError,
    dateOfBirthError,
    isInfantSelectedForDeletion: passengersSelectedForDeletion.includes(
      infantId
    ),
    isDeleteCheckboxDisabled: passengersSelectedForDeletion.includes(
      passengerId
    ),
    infantDateOfBirthValidator: maxDifferenceTwoYearsBetweenDates(
      departureDate
    ),
    isDeletePassengersEnabled: state.deletePassengers.isDeletePassengersEnabled,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  validateInfantDateOfBirth: (
    targetElement: HTMLInputElement,
    passengerId: string,
    infantDateOfBirthValidator: Function,
    dateOfBirthError?: NotificationInterface
  ) =>
    infantDateOfBirthValidation(
      targetElement,
      passengerId,
      infantDateOfBirthValidator,
      dispatch,
      dateOfBirthError
    ),

  removeNotification: (notificationId: string) => {
    dispatch(removeNotification(notificationId))
  },

  selectPassengerForDeletion: (infantId: string) => {
    dispatch(selectPassengerForDeletion(infantId))
  },

  deselectPassengerForDeletion: (infantId: string) => {
    dispatch(deselectPassengerForDeletion(infantId))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditBookingFormInfantRow)
